import { ApiExplorerFieldDropdownOption } from '@squareup/dex-ui-shared-api-explorer-providers';

const sourceIdOptions: Array<ApiExplorerFieldDropdownOption> = [
  { value: 'cnon:card-nonce-ok', description: 'Test a card payment' },
  {
    value: 'ccof:customer-card-id-ok',
    description: 'Test a card on file payment',
  },
  { value: 'cnon:gift-card-nonce-ok', description: 'Test a gift card payment' },
  { value: 'CASH', description: 'Test a cash payment' },
  { value: 'EXTERNAL', description: 'Test an external payment' },
  {
    value: 'cnon:card-nonce-rejected-cvv',
    description: 'Test a card payment that fails due to CVV validation',
  },
  {
    value: 'cnon:card-nonce-rejected-postalcode',
    description: 'Test a card payment that fails due to postal code validation',
  },
  {
    value: 'cnon:card-nonce-rejected-expiration',
    description:
      'Test a card payment that fails due to expiration date validation',
  },
  {
    value: 'cnon:card-nonce-declined',
    description: 'Test a card payment that fails due to a generic decline',
  },
  {
    value: 'cnon:card-nonce-already-used',
    description: 'Test a card payment that fails due to re-using a token',
  },
  {
    value: 'cnon:gift-card-nonce-insufficient-funds',
    description:
      'Test a gift card payment that fails due to insufficient funds',
  },
  {
    value: 'cnon:gift-card-nonce-insufficient-permission',
    description:
      'Test a gift card payment that fails due to insufficient permissions',
  },
  {
    value: 'bnon:bank-nonce-ok',
    description: 'Test a bank payment',
  },
  {
    value: 'bnon:bank-nonce-failure',
    description: 'Test a bank payment that fails due to a generic decline',
  },
  {
    value: 'bnon:bank-nonce-account-unusable',
    description: 'Test a bank payment that fails due to an unusable account',
  },
  {
    value: 'bnon:bank-nonce-insufficient-funds',
    description: 'Test a bank payment that fails due to insufficient funds',
  },
  {
    value: 'bnon:bank-nonce-invalid-account',
    description: 'Test a bank payment that fails due to an invalid account',
  },
  {
    value: 'bnon:bank-nonce-buyer-refused-payment',
    description: 'Test a bank payment that fails due to buyer refusing payment',
  },
];

const sourceIdDropdownOptions: Record<
  string,
  Array<ApiExplorerFieldDropdownOption>
> = {
  source_id: sourceIdOptions,
};

export { sourceIdDropdownOptions };
